<div class="table-wrapper">
  <table fd-table class="atom-table" [noBorderX]="true" [noBorderY]="true">
    <thead fd-table-header>
      <tr fd-table-row class="atom-table-row">
        <th fd-table-cell>TYPE</th>
        <th fd-table-cell>STATUS</th>
        <th fd-table-cell>REASON</th>
        <th fd-table-cell>OBSERVED GENERATION</th>
        <th fd-table-cell>MODIFIED ON</th>
        <th fd-table-cell>MESSAGE</th>
      </tr>
    </thead>

    <tbody fd-table-body>
      @for (condition of resource?.conditions; track condition) {
        <tr
          fd-table-row
          class="atom-table-row"
          [class]="
            condition?.observedGeneration ===
            resource?.resource?.metadata?.generation
              ? ''
              : 'disabled'
          "
        >
          <td fd-table-cell>{{ condition.type }}</td>
          <td fd-table-cell>{{ condition.status }}</td>
          <td fd-table-cell>{{ condition.reason }}</td>
          <td fd-table-cell>{{ condition.observedGeneration }}</td>
          <td fd-table-cell>
            <app-date [date]="condition?.lastTransitionTime"></app-date>
          </td>
          <td fd-table-cell>{{ condition.message }}</td>
        </tr>
      }
    </tbody>
  </table>
</div>
